<template>
  <div class="c-fines-info">
    <div class="message">
      <div class="message-container">
        <div class="text">
          <h3>{{ heading }}</h3>
          <h3 class="little">{{ title }}</h3>
          <div v-if="typeof data === 'object' ? Object.keys(data).length > 0 : data.length > 0" class="datas">
            <div v-for="(items, key) in data" :key="key" class="data-row">
              <div class="left">{{ key }}</div>
              <div class="right">
                <div v-for="(item, index) in items" :key="index" class="info">
                  {{ item }}
                </div>
              </div>
            </div>
          </div>
          <div v-else class="datas">
            <div class="data-row">
              <div class="info">
                Не было начислено штрафов или наград
              </div>
            </div>
          </div>
        </div>
        <div class="buttons">
          <n-button flat class="modal-button" @click="close">Закрыть</n-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'CFinesInfo',
  props: {
    heading: {
      type: String,
      default: 'Инфо штрафов и наград:',
    },
    title: {
      type: String,
      required: true,
    },
    data: {
      default() {
        return []
      },
    },
  },
  data() {
    return {
    }
  },
  methods: {
    close() {
      this.$emit('update:show', false)
      this.$emit('close')
    },
  },
}
</script>

<style scoped lang="scss">
.c-fines-info {
  position: fixed;
  display: flex;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 1020;
  background: rgba(0, 0, 0, 0.05);
  align-items: center;
  justify-content: center;
  .message {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #FFFFFF;
    border-radius: 16px;
    padding: 15px;
    .message-container {
      .text {
        h3 {
          margin: 0 0 4px 0;
          padding: 0;
          font-size: 18px;
          font-weight: 700;
          color: var(--primary);
          text-align: center;
          &.little {
            font-size: 16px;
          }
        }
        p {
          text-align: center;
          margin: 12px 0 12px 0;
          color: var(--primary);
          padding: 0;
          font-size: 16px;
        }
      }
      .datas {
        overflow: auto;
        max-height: 400px;
        margin-top: 15px;
        .data-row {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 10px;
          border-radius: 12px;
          background-color: #f1f4fb;
          margin-bottom: 5px;
          .left {
            width: 100px;
            text-align: center;
            margin-right: 15px;
            background-color: var(--primary);
            border-radius: 6px;
            color: #ffffff;
            padding: 5px 10px;

          }
          .right {
            background-color: rgba(212, 224, 248, 0.55);
            border-radius: 6px;
            padding: 5px 10px;
            font-weight: 500;
            width: 500px;
          }
          .left,.right {
            padding: 5px;
          }
        }
      }

      .buttons {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        min-width: 250px;
        margin-top: 20px;
        :deep() {
          .n-button {
            border: none;
            border-radius: 12px;
            height: 38px;
            min-width: 120px;
            background-color: var(--primary);
            color: #FFFFFF;

            &.cancel {
              background-color: #ffffff;
              color: var(--primary);
              font-weight: 700;
              border: 1px solid var(--primary);
            }
          }
        }
      }
    }
  }
}
.close-modal {
  display: none;
}
</style>
